import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { QueryKey } from 'consts/query/queryKey'
import { ChanneledRequestParams, Queue } from 'types'

import { getQueues } from './requests'

export const useQueuesQuery = (
  params: ChanneledRequestParams,
  options: Partial<UseQueryOptions<Queue[]>> = {},
) => {
  return useQuery({
    queryKey: [QueryKey.GetQueues, params],
    queryFn: () => getQueues(params),
    ...options,
  })
}
